import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IContainer, IContainerCriteria } from '../container.interface';
import * as _ from 'underscore';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-container-list',
    templateUrl: './container-list.component.html',
    styleUrls: ['./container-list.component.less'],
    standalone: false
})
export class ContainerListComponent implements OnInit,AfterViewInit, OnDestroy {

  constructor(private logger:NGXLogger,private service:DataService,private formBuilder:FormBuilder,
              private utilityService:UtilityService, private router:Router,private activatedRoute:ActivatedRoute,
              private permissionService:PermissionService) { }

  containerListForm:FormGroup;
  containerDataSource=new MatTableDataSource<IContainer>();
  totalRecords:any;
  pageSizeOptions=this.utilityService.getPageSizeOptions();
  containerColumns:string[]=['name','size','equipmentType.name','status','action'];
  criteria:IContainerCriteria={};
  statusTypes:any=[];
  equipmentSizes=this.utilityService.getEquipmentSizeList();
  addPermission : boolean = false;
  editPermission : boolean = false;
  viewPermission : boolean = false;
  @ViewChild(MatSort)  sort:MatSort;
  @ViewChild(MatPaginator) paginator:MatPaginator;
	subscription = new Subscription();

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.setNameValueChangeEvent();
    this.setSizeValueChangeEvent();
    this.setEquipmentValueChangeEvent();
    this.setStatusValueChangeEvent();
    this.getStatusTypes();
  }

  ngAfterViewInit() {
    this.criteria.page = 0;
    this.criteria.size = 20;
    this.containerDataSource.paginator = this.paginator;
    this.containerDataSource.sort = this.sort;
    this.paginator?.page?.pipe(tap(() => this.getContainerList())).subscribe();
    this.getContainerList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
  initializeForm(){
    this.containerListForm=this.formBuilder.group({
       name:[],
       size:[],
       equipment:[],
       status:[],
    });
  }

  sortData(event){
    this.criteria.sort = [event.active, event.direction];
    this.getContainerList(true);
  }


  setNameValueChangeEvent(){
    this.subscription = this.name.valueChanges.subscribe(nameValue => {
       this.criteria.name=nameValue;
       this.getContainerList(true);
    });
  }

  setSizeValueChangeEvent(){
    const sub = this.size.valueChanges.subscribe(sizeValue => {
      this.criteria.equipmentSize=sizeValue;
      this.getContainerList(true);
    });
    this.subscription.add(sub);
  }

  setEquipmentValueChangeEvent(){
    const sub = this.equipment.valueChanges.subscribe(equipmentValue => {
      this.criteria.equipmentTypeName=equipmentValue;
      this.getContainerList(true);
    });
    this.subscription.add(sub);
  }

  setStatusValueChangeEvent(){
    const sub = this.status.valueChanges.subscribe(statusValue => {
      this.criteria.status=statusValue;
      this.getContainerList(true);
    });
    this.subscription.add(sub);
  }

  openContainerForm(id?:number){
    if(id){
      this.addPermission ? this.router.navigate(['edit/'+id],{relativeTo:this.activatedRoute}) : 
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
    } else {
      this.editPermission ? this.router.navigate(['add'],{relativeTo:this.activatedRoute}) : 
        this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    }
  }

  getContainerList(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    if(this.viewPermission){
      this.service.get(Api.CONTAINER,this.criteria).subscribe(res => {
        if(res){
          this.containerDataSource=res.contents;
          this.totalRecords=res.totalRecords;
          if (this.paginator.pageIndex >= Math.ceil(this.totalRecords / this.paginator.pageSize)) {
            this.paginator.pageIndex = 0;
          }
        }
     });
    } else
      this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
  }

  getStatusTypes() {
    this.service.get(Api.STATUS_TYPE_LIST).subscribe(res => {
      this.statusTypes.push({key: "", label: "Search by Status"});
      this.statusTypes.push(...res);
    });
  }

  public checkAllPermission(){
    const permissionCodes=[PermissionKey.CONTAINER_MODULE_ADD_PERMISSION,PermissionKey.CONTAINER_MODULE_DELETE_PERMISSION,
      PermissionKey.CONTAINER_MODULE_EDIT_PERMISSION,PermissionKey.CONTAINER_MODULE_VIEW_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.CONTAINER_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_ADD_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_VIEW_PERMISSION})?.show?true:false;
  }

  get name(){ return this.containerListForm.get('name') };
  get size(){ return this.containerListForm.get('size') };
  get equipment(){ return this.containerListForm.get('equipment') };
  get status(){ return this.containerListForm.get('status') };
}
